// src/apiService.js
import axios from 'axios'
// const baseURL = process.env.REACT_APP_BASE_URL
const baseURL = "https://shuskin.com"

const api = await axios.create({
    baseURL: baseURL, // Replace with your API base URL
    headers: {
        'Content-Type': 'application/json',
    },
})

api.interceptors.request.use((config) => {
    const token = localStorage.getItem('token')
    if (token) {
        config.headers.Authorization = `Bearer ${token}`
    }
    return config
})

// Interceptors for responses
api.interceptors.response.use(
    (response) => {
        return response
    },
    (error) => {
        if (error.response.status === 401) {
            localStorage.removeItem('token')
            localStorage.removeItem('role')
            localStorage.removeItem('email')
            localStorage.removeItem('user_id')

            window.location.href = '/login'
        }
        return Promise.reject(error)
    },
)

export default api
